<template>
    <div class="homeBox">
        <div class="flex-box" style="align-items: center;">

<!--            <div class="content-icon-box" @click="clickView('shop')" v-if="shopTag && null != userInfoRef.acccompanycode">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-shop" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="3D店鋪">{{i18n.tkey("lang_my_3D_shop")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的店鋪">{{i18n.tkey("lang_3d_shop_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="content-icon-box" @click="clickView('openShop')" v-if="userInfoRef.addinfo6 == -1 && null == userInfoRef.acccompanycode">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-shop" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="開通店鋪">{{i18n.tkey("lang_open_shop_3d")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的店鋪">{{i18n.tkey("lang_3d_shop_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="content-icon-box" @click="clickView('chat')">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-comments" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span>Chat</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span>3DShopopee Chat</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="content-icon-box">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-users" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="3D展會">{{i18n.tkey("lang_3d_exhibition")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的展會">{{i18n.tkey("lang_3d_exhibition_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <a :href="websiteUrl" target="_blank" v-if="shopTag">-->
<!--            <div class="content-icon-box">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-globe" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="我的網站">{{i18n.tkey("lang_my_website")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的網站">{{i18n.tkey("lang_my_website_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            </a>-->

            <HomeIconBoxDetail
                :label="i18n.tkey('lang_my_memberwork')"
                :detail="i18n.tkey('lang_my_card_des')"
                @click="clickView('mycard')"
                tkey="我的名片"
            >
                <font-awesome-icon icon="fa-solid fa-address-card" />
            </HomeIconBoxDetail>

            <HomeIconBoxDetail
                :label="i18n.tkey('lang_island_manage')"
                :detail="i18n.tkey('lang_island_manage_des')"
                v-if="islandFlag"
                @click="clickView('islandManager')"
                tkey="島嶼管理"
            >
                <font-awesome-icon icon="fa-solid fa-mountain-city" />
            </HomeIconBoxDetail>

<!--            <div class="content-icon-box">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-address-card" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="我的名片">{{i18n.tkey("lang_my_memberwork")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的名片">{{i18n.tkey("lang_my_card_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <a :href="managerUrl" target="_blank" v-if="shopTag">-->
<!--            <div class="content-icon-box">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-people-roof" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="企業管理系統">{{i18n.tkey("lang_company_manage_sys")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的後台中心">{{i18n.tkey("lang_manage_sys_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            </a>-->

            <homeIconBoxShadow
                :label="i18n.tkey('lang_my_quotation')"
                @click="clickView('myQuotation')"
                v-if="hideEshopopeeFlag"
                tkey="我的報價單"
            >
                <font-awesome-icon icon="fa-solid fa-file-lines" />
            </homeIconBoxShadow>

          <homeIconBoxShadow
              :label="i18n.tkey('lang_my_hall_order')"
              @click="clickView('myHallOrder')"
              v-if="hideEshopopeeFlag"
              tkey="我的展會單"
          >
            <font-awesome-icon icon="fa-solid fa-file-invoice-dollar" />
          </homeIconBoxShadow>

<!--            <div class="content-icon-box" @click="clickView('myQuotation')">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-file-invoice-dollar" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="我的報價單">{{i18n.tkey("lang_my_quotation")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--&lt;!&ndash;                        <span tkey="查看及管理您的報價單">{{i18n.tkey("lang_quotation_des")}}</span>&ndash;&gt;-->
<!--                        <span>&nbsp;</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="content-icon-box" @click="clickView('setting')">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-gear" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="設置">{{i18n.tkey("lang_setting")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="網站設置">{{i18n.tkey("lang_website_setting")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

        </div>
    </div>
</template>

<script setup>

//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGlobe,faFileLines, faShop, faUsers, faAddressCard, faPeopleRoof, faGear, faFileInvoiceDollar, faComments, faMountainCity } from '@fortawesome/free-solid-svg-icons'
import {inject, computed, toRef, getCurrentInstance, ref, onBeforeMount} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import {useCompanyinfo} from "@/stores/companyinfo";
import myUtil from "@/util/util";
import HomeIconBoxDetail from "@/components/shopopee/common/homeIconBoxDetail.vue";
import homeIconBoxShadow from "@/components/shopopee/common/homeIconBoxShadow.vue";

library.add(faGlobe,faFileLines, faShop, faUsers, faAddressCard, faPeopleRoof, faGear, faFileInvoiceDollar, faComments, faMountainCity)

const emits = defineEmits(["clickIcon"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())
//響應機制的companyinfo
const companyInfoRef = toRef(useCompanyinfo())
const { proxy } = getCurrentInstance()

const companyObj = ref({})

const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return userInfoRef.value } })

// const websiteUrl = computed(() => {
//     let url = myUtil.generateEShopopeeShopUrl(userInfoRef.value.acccompanycode)
//     return url
// })

// const managerUrl = computed(() => {
//     const url = myUtil.generateEshopopeeManagerUrl(companyObj.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword)
//     return url
// })
//
// const shopTag = computed(() => {
//     let flag = myUtil.isNotEmpty(userInfoRef.value.acccompanycode) && userInfoRef.value.addinfo6 == -1
//
//     return flag
// })

const islandFlag = computed(() => {
    let flag = (null != companyInfoRef.value.additionalrecord11 && null != companyInfoRef.value.additionalrecord11.islandNum && companyInfoRef.value.additionalrecord11.islandNum > 0)

    return flag
})

const hideEshopopeeFlag = computed(() => {
    let flag = false

    flag = companyInfoRef.value.dinumber == -1

    return !flag
})

function clickView(name){
    emits("clickIcon", name)
}

onBeforeMount(() => {
    companyObj.value = getShopCompanyObj()
})

</script>

<style scoped>

.homeBox {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
}
@media screen and (min-width: 520px) {
    .flex-box {
        display: flex;
        flex-wrap: wrap;
        word-break: break-all;
    }
}

@media screen and (max-width: 520px) {
    .flex-box {
        display: flex;
        flex-wrap: wrap;
        word-break: break-all;
        justify-content: center;
    }
}

a:-webkit-any-link {
    color: unset;
    cursor: pointer;
    text-decoration: none;
}

a {
    color: unset;
    cursor: pointer;
    text-decoration: none;
}
</style>